import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialProductSchemeState: IProductSchemeState = {
  data: {
    product_scheme: [],
    meta: {},
  },
  activateSuccess: false,
  deactivateSuccess: false,
  singleActivateSuccess: false,
  singleDeactivateSuccess: false,
  loading: false,
  success: false,
  deleteSuccess: false,
}

export interface IProductSchemeState {
  data: {
    product_scheme?: {[key: string]: string | number}[]
    meta?: {[key: string]: number}
  }
  activateSuccess: boolean
  deactivateSuccess: boolean
  singleActivateSuccess: boolean
  singleDeactivateSuccess: boolean
  loading?: boolean
  deleteSuccess?: boolean
  success?: boolean
}

export const reducer = (
  state: IProductSchemeState = initialProductSchemeState,
  action: ActionWithPayload<IProductSchemeState>
) => {
  switch (action.type) {
    case actionTypes.GET_PRODUCT_SCHEME_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_PRODUCT_SCHEME_SUCCESS: {
      return {...state, data: action.payload?.data, loading: false}
    }

    case actionTypes.GET_PRODUCT_SCHEME_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.GET_PRODUCT_SCHEME_DROPDOWN_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_PRODUCT_SCHEME_DROPDOWN_SUCCESS: {
      return {...state, data: action.payload?.data, loading: false}
    }

    case actionTypes.GET_PRODUCT_SCHEME_DROPDOWN_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_PRODUCT_SCHEME_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_PRODUCT_SCHEME_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_PRODUCT_SCHEME_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_PRODUCT_SCHEME_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.UPDATE_PRODUCT_SCHEME_START: {
      return {
        ...state,
        loading: true,
      }
    }

    case actionTypes.UPDATE_PRODUCT_SCHEME_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_PRODUCT_SCHEME_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.UPDATE_PRODUCT_SCHEME_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.DELETE_PRODUCT_SCHEME_START: {
      return {...state, loading: true, deleteSuccess: false}
    }

    case actionTypes.DELETE_PRODUCT_SCHEME_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_PRODUCT_SCHEME_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Singer activate branchless banking

    case actionTypes.SINGLE_ACTIVATE_PRODUCT_SCHEME_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_PRODUCT_SCHEME_SUCCESS: {
      const changedData: any = action.payload
      let newData = state?.data?.product_scheme?.map((data) => {
        if (data?.id === changedData?.product_scheme[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, product_scheme: newData},
        singleActivateSuccess: true,
        toggleLoading: false,
      }
    }
    case actionTypes.SINGLE_ACTIVATE_PRODUCT_SCHEME_FINISH: {
      return {...state, singleActivateSuccess: false, toggleLoading: false}
    }

    //Singer Deactivate branchless banking
    case actionTypes.SINGLE_DEACTIVATE_PRODUCT_SCHEME_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DEACTIVATE_PRODUCT_SCHEME_SUCCESS: {
      const changedData: any = action.payload
      let newData = state?.data?.product_scheme?.map((data) => {
        if (data?.id === changedData?.product_scheme[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, product_scheme: newData},
        singleDeactivateSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DEACTIVATE_PRODUCT_SCHEME_FINISH: {
      return {...state, singleDeactivateSuccess: false, toggleLoading: false}
    }

    default:
      return state
  }
}
